import React, { useState, useEffect } from "react";
import { data } from "../constants/data";
import { FaStar, FaGitAlt, FaGithub, FaLaptopCode } from "react-icons/fa";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Projects = (props) => {
  // const repos = () =>{
  //     try {
  //         const username = data.githubUsername;
  //         const res = await axios.get(`https://api.github.com/search/repositories?q=user:${username}+sort:author-date-asc`);
  //         let repos = res.data.items;
  //         let latestSixRepos = repos.splice(0, 6);
  //         return latestSixRepos;
  //     } catch (err) {
  //         console.log(err);
  //     }
  // }

  console.log(data);
  const username = data.githubUsername;
  //const url = `https://api.github.com/search/repositories?q=user:${username}+sort:author-date-asc`
  const urlPinnes = `https://gh-pinned-repos.egoist.dev/?username=${username}`;

  const [loading, setLoading] = useState(true);
  // const [projects, setProjects] = useState([])
  const [pinnedProjects, setPinnedProjects] = useState([]);

  const fetchPinnedProjects = async () => {
    setLoading(true);
    try {
      const response = await fetch(urlPinnes);
      const tours = await response.json();
      setLoading(false);
      setPinnedProjects(tours);
    } catch (error) {
      setLoading(false);
      console.log("Error Occured");
      console.log(error);
    }
  };

  // useEffect(() => {
  //     fetchProjects()
  // }, [])
  useEffect(() => {
    fetchPinnedProjects();
  }, []);

  const ProjectsLoading = () => {
    return (
      <>
        <a className="hover:shadow" href="" target="_blank" rel="noreferrer">
          <div className="max-w-4xl m-auto flex justify-between border border-gray-200 dark:border-gray-800 rounded p-4 hover:shadow hover:border hover:border-gray-300 dark:hover:border dark:hover:border-sky-500">
            <div className=" ml-2 mr-4">
              <FaLaptopCode className="text-lg" />
            </div>
            <div className="w-10/12">
              <h4 className="w-full text-lg font-bold tracking-tight text-gray-900 dark:text-gray-100">
                <Skeleton
                  baseColor="#111827"
                  count={1}
                  highlightColor="#1f2937"
                />
              </h4>
              <p className="leading-5 text-gray-700 dark:text-gray-300">
                <Skeleton
                  baseColor="#111827"
                  count={2}
                  highlightColor="#1f2937"
                />
              </p>
              <div className="pt-2 flex  md:flex-row space-x-2">
                {/* <p className='leading-5 text-gray-700 dark:text-gray-300 dark:bg-transparent rounded-md text-xs italic bg-gray-50  '>{props.language}</p> */}
                <p className="flex leading-5 text-gray-700 dark:text-gray-300 dark:bg-transparent rounded-sm italic bg-gray-50 ">
                  <FaStar className="text-amber-300" />
                  <Skeleton
                    baseColor="#111827"
                    count={2}
                    highlightColor="#1f2937"
                  />
                </p>
                <p className="flex flex leading-5 text-gray-700 dark:text-gray-300 dark:bg-transparent rounded-sm italic bg-gray-50 ">
                  <FaGitAlt className="text-cyan-300" />
                  <Skeleton
                    baseColor="#111827"
                    count={2}
                    highlightColor="#1f2937"
                  />
                </p>
              </div>
            </div>
          </div>
        </a>
        <br />
      </>
    );
  };

  const ProjectsCard2 = ({ props }) => {
    return (
      <>
        <a
          className="mb-4 hover:shadow"
          href={props.link}
          target="_blank"
          rel="noreferrer"
        >
          <div className="max-w-2xl m-auto flex items-center border border-gray-200 dark:border-gray-800 rounded p-4 hover:shadow hover:border hover:border-gray-300 dark:hover:border dark:hover:border-sky-500">
            <div className="h-10 w-20 ml-2 mr-4">
              {/* <FaLaptopCode className='text-lg' /> */}
              <img src={props.image} alt={props.repo} />
            </div>
            <div>
              <h4 className="text-lg font-bold tracking-tight text-gray-900 dark:text-gray-100">
                {props.repo || (
                  <Skeleton
                    baseColor="#111827"
                    count={2}
                    highlightColor="#1f2937"
                  />
                )}
              </h4>
              <p className="leading-5 text-gray-700 dark:text-gray-300">
                {props.description || (
                  <Skeleton
                    baseColor="#111827"
                    count={2}
                    highlightColor="#1f2937"
                  />
                )}
              </p>
              <div className="pt-2 flex  md:flex-row space-x-2">
                {/* <p className='leading-5 text-gray-700 dark:text-gray-300 dark:bg-transparent rounded-md text-xs italic bg-gray-50  '>{props.language}</p> */}
                <p className="flex leading-5 text-gray-700 dark:text-gray-300 dark:bg-transparent rounded-sm italic bg-gray-50 ">
                  <FaStar className="text-amber-300" />
                  {props.stars || (
                    <Skeleton
                      baseColor="#111827"
                      count={2}
                      highlightColor="#1f2937"
                    />
                  )}
                </p>
                <p className="flex flex leading-5 text-gray-700 dark:text-gray-300 dark:bg-transparent rounded-sm italic bg-gray-50 ">
                  <FaGitAlt className="text-cyan-300" />
                  {props.forks || (
                    <Skeleton
                      baseColor="#111827"
                      count={2}
                      highlightColor="#1f2937"
                    />
                  )}
                </p>
              </div>
            </div>
          </div>
        </a>
        <br />
      </>
    );
  };

  if (props.type === "pre") {
    if (loading) {
      return (
        <div className="flex flex-col">
          <ProjectsLoading />
          <ProjectsLoading />
          <ProjectsLoading />
        </div>
      );
      // return <Skeleton baseColor='#111827' count={2} highlightColor='#1f2937' />
    }
    // console.log(projects);
    return (
      <>
        {pinnedProjects.slice(0, 3).map((data) => {
          return <ProjectsCard2 props={data} key={data.repo} />;
        })}
      </>
    );
  } else {
    if (loading) {
      return (
        <div>
          <h3 className="font-bold text-2xl md:text-4xl tracking-tight mb-4 mt-8 text-black dark:text-white">
            Projects
          </h3>
          <div className="">
            <ProjectsLoading />
            <ProjectsLoading />
            <ProjectsLoading />
          </div>
        </div>
      );
    }
    return (
      <>
        <div>
          <h3 className="font-bold text-2xl md:text-4xl tracking-tight mb-4 mt-8 text-black dark:text-white">
            Projects
          </h3>
          {pinnedProjects.map((data) => {
            return <ProjectsCard2 props={data} key={data.repo} />;
          })}
          <br />
        </div>
        <a
          href="https://github.com/sahiljena"
          className="border flex flex-row items-center justify-center mx-auto rounded-md dark:text-gray-300 px-4 py-2 text-gray-800"
        >
          See all at <FaGithub className="mx-2 text-base" />
        </a>
      </>
    );
  }
};

export default Projects;
